import React from "react";
import { Box, Text, Stack } from "@bookingcom/bui-react";
import { trackWithDefaultStage } from "@flights/et-universal";
import { useI18n } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
import * as etV2 from "@flights/et-universal";
import { SearchboxController, SearchBoxHorizontalDefault } from "@bookingcom/flights-searchbox";

import Container from "../Container";
import NoJS from "screens/NoJS";
import useSearchbox from "hooks/useSearchbox";
import useLocaleContext from "hooks/useLocaleContext";
import useLandingPageEvents from "hooks/c360/useLandingPageEvents";

import styles from "./HomeSearchHeader.desktop.module.css";
import flights_web_trip_type_dropdown_desktop, {
  useTrackTripTypeDropdownDesktop
} from "utils/experiments/funnel/flights_web_trip_type_dropdown_desktop";

const HomeSearchHeader = () => {
  const i18n = useI18n();
  const searchBoxProps = useSearchbox();
  const { isRTL } = useLocaleContext();
  const trackLandingPageEvents = useLandingPageEvents();

  const isResponsiveFixes = !!trackWithDefaultStage("flights_web_cat_responsive_fixes_www", 1);

  useTrackTripTypeDropdownDesktop();

  return (
    <>
      <Box className={styles.titleBox}>
        <Container className={styles.titleContainer}>
          <NoJS />
          <Stack gap={1} className={styles.titleStack} direction="row" justifyContent="start">
            <Stack.Item grow className={styles.titleStackItem}>
              <Text variant="display_3" data-testid="home_header" tagName="h1" color="white" className={styles.title}>
                {i18n.trans(t("flights_index_header_compare_book_ease"))}
              </Text>
              <Text variant="featured_2" color="white" className={styles.subtitle}>
                {i18n.trans(t("flights_index_header_discover_next_dream"))}
              </Text>
            </Stack.Item>
          </Stack>
        </Container>
      </Box>

      <Box className={`${styles.searchboxControllerBox} ${isResponsiveFixes ? styles.searchboxControllerBoxRes : ""}`}>
        <Container
          className={`${
            isResponsiveFixes ? styles.searchBoxControllerContainerRes : styles.searchBoxControllerContainer
          }`}
        >
          <SearchboxController
            i18n={i18n}
            {...searchBoxProps}
            hideShadow={true}
            isRTL={isRTL}
            isHeaderUpdateExp={true}
            isResponsiveFixes={isResponsiveFixes}
            enabledCountriesAndAnywhere={true}
            isDropdownExp={!!flights_web_trip_type_dropdown_desktop.trackWithDefaultStage()}
            isEmptyDestinationExp={!!trackWithDefaultStage("flights_web_cat_empty_destination_www", 1)}
            onSearch={(searchParams) => {
              trackLandingPageEvents("click", "searchbox");
              etV2.customGoal("mvsf_whs_launchpad_stays_flights_www", 2);
              searchBoxProps.onSearch(searchParams);
            }}
          >
            {SearchBoxHorizontalDefault}
          </SearchboxController>
        </Container>
      </Box>
    </>
  );
};

export default HomeSearchHeader;
